import { BaseNamespace } from 'stores/BaseNamespace';
import { ModuleStore } from './stores';
import { DiscoverStore } from './stores/DiscoverStore';

export class DashboardNamespace extends BaseNamespace {
  public modules = new ModuleStore(this.rootStore);
  public discover = new DiscoverStore(this.rootStore);
}
